import React, { FunctionComponent, useEffect, useState } from 'react';
import * as games from '@stores/games';
import * as platforms from '@stores/platforms';
import * as gamesRequest from '@stores/gamesRequest/gamesRequest';
import GamesList from '@components/GamesList';
import GamesListHeader from '@components/GamesListHeader';
import GameEditModal from '@components/GameEditModal';
import { Tabs } from 'antd';
import { GamesRequest } from '@pages/GamesPage';

interface GamesRouteProps {}

const GamesRoute: FunctionComponent<GamesRouteProps> = () => {
  const [activeTab, setActiveTab] = useState('list');
  useEffect(() => {
    platforms.getList();
    return () => {
      games.reset();
      platforms.reset();
      gamesRequest.reset();
    };
  }, []);

  useEffect(() => {
    if (activeTab === 'list') {
      games.getList();
      gamesRequest.reset();
    } else {
      gamesRequest.getList();
      games.reset();
    }
  }, [activeTab]);
  return (
    <div>
      <Tabs
        defaultActiveKey='list'
        type='card'
        onChange={(key) => setActiveTab(key)}
        activeKey={activeTab}
      >
        <Tabs.TabPane tab='List' key='list'>
          <GamesListHeader />
          <GamesList />
        </Tabs.TabPane>
        <Tabs.TabPane tab='Request' key='request'>
          <GamesRequest />
        </Tabs.TabPane>
      </Tabs>
      <GameEditModal />
    </div>
  );
};

export default GamesRoute;
